var _a;
import { Enter, Exit, Elevator, Stairs, Bar, Cutlery, Smoking, Wc, WcWomen, WcMen } from 'wix-ui-icons-common';
import { IconType } from '../interfaces';
export var ICONS = (_a = {},
    _a[IconType.enter] = Enter,
    _a[IconType.exit] = Exit,
    _a[IconType.elevator] = Elevator,
    _a[IconType.stairs] = Stairs,
    _a[IconType.drinks] = Bar,
    _a[IconType.food] = Cutlery,
    _a[IconType.smoking] = Smoking,
    _a[IconType.wc] = Wc,
    _a[IconType.wcWomen] = WcWomen,
    _a[IconType.wcMen] = WcMen,
    _a);
//# sourceMappingURL=icons.js.map